import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Portal from '@clearscore/helpers.portal';
import Icon from '@clearscore/rainbow.icons.cross';
import toTitleCase from '@clearscore/normalize.title-case';
import Exclusive from '@clearscore/rainbow.icons.exclusive';

import styles from './overlay.css';
import { themes } from './constants';

const Backdrop = ({ isShown, onClick }) => (
    <div onClick={onClick} data-qa="backdrop" className={cx(styles.backdrop, { [styles.isShown]: isShown })} />
);

Backdrop.propTypes = {
    isShown: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
};

Backdrop.defaultProps = {
    onClick: null,
};

const ExclusivePattern = ({ isFlipped }) => (
    <div className={cx(styles.exclusive, { [styles.isFlipped]: isFlipped })} data-qa="overlay-exclusive-pattern">
        <Exclusive />
    </div>
);

ExclusivePattern.propTypes = {
    isFlipped: PropTypes.bool,
};

ExclusivePattern.defaultProps = {
    isFlipped: false,
};

const Overlay = ({
    children,
    dataId,
    hasBackdrop,
    isCloseable,
    isShown,
    isVerticallyCentered,
    isWrappedContent,
    onBackdropClick,
    onClose,
    theme,
}) => {
    const isBackdropShown = hasBackdrop && isWrappedContent && isShown;

    return isShown ? (
        <Portal>
            {isBackdropShown ? <Backdrop onClick={onBackdropClick} isShown={isBackdropShown} /> : null}
            <div
                className={cx(styles.component, styles[`isTheme${toTitleCase(theme)}`], {
                    [styles.isVerticallyCentered]: isVerticallyCentered,
                    [styles.isWrappedContent]: isWrappedContent,
                })}
                role="dialog"
                data-qa="overlay"
                data-id={dataId}
            >
                <If condition={isCloseable}>
                    <button className={styles.close} type="button" onClick={onClose} data-qa="overlay-close-button">
                        <Icon height={32} width={32} />
                    </button>
                </If>
                <If condition={isWrappedContent}>
                    <ExclusivePattern />
                    <ExclusivePattern isFlipped />
                </If>

                <div className={cx(styles.content, { [styles.isWrappedContent]: isWrappedContent })}>{children}</div>
            </div>
        </Portal>
    ) : null;
};
Overlay.themes = themes;
export default Overlay;

Overlay.propTypes = {
    children: PropTypes.node.isRequired,
    dataId: PropTypes.string,
    hasBackdrop: PropTypes.bool,
    isCloseable: PropTypes.bool,
    isShown: PropTypes.bool,
    isVerticallyCentered: PropTypes.bool,
    isWrappedContent: PropTypes.bool,
    onBackdropClick: PropTypes.func,
    onClose: PropTypes.func,
    theme: PropTypes.oneOf(Object.values(themes)),
};

Overlay.defaultProps = {
    dataId: undefined,
    hasBackdrop: false,
    isCloseable: true,
    isShown: true,
    isVerticallyCentered: false,
    isWrappedContent: false,
    onBackdropClick: null,
    onClose: undefined,
    theme: themes.OVERLAY,
};
